import {
  Box,
  Flex,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  VStack,
} from "@chakra-ui/react";
import PlanService from "../../services/PaidPlan";
import { useEffect, useState } from "react";
import { Table } from "../../components/PaidPlan/Table";
export const ProRequestList = () => {
  const rowStyles = {
    "&:nth-of-type(odd)": {
      bg: "gray.100",
    },
  };
  const [summary, setSummary] = useState({
    allPurchases: 0,
    plusPurchases: 0,
    singleProPurchases: 0,
    allProPurchases: 0,
  });

  const filterList = (array: any) => {
    const list = array.filter(
      (el: any) => el.plan_name === "PRO_SINGLE" || el.plan_name === "PRO_ALL"
    );
    setFilteredData(list);
  };
  const getSummmary = (arr: any[]) => {
    let allPurchases = arr.length;
    let plusPurchases = 0;
    let singleProPurchases = 0;
    let allProPurchases = 0;
    let noPlan = 0;
    arr.map((el) => {
      if (el.plan_name === "THERAPY_PLUS") plusPurchases++;
      else if (el.plan_name === "PRO_SINGLE") singleProPurchases++;
      else if (el.plan_name === "PRO_ALL") allProPurchases++;
      else noPlan++;
    });
    setSummary({
      allPurchases,
      allProPurchases,
      singleProPurchases,
      plusPurchases,
    });
  };
  const [filterData, setFilteredData] = useState([]);
  const fetchData = () => {
    PlanService.getAllplans()
      .then((res) => {
        filterList(res.data);
        getSummmary(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <>
      <div className="main-wrapper">
        <div className="page_title py-2">Paid Plans - Pro</div>

        <div className=" p-4">
          <Flex justifyContent={"space-between"}>
            <VStack width="45%" p={4}>
              <Box w="100%" p={1} __css={rowStyles}>
                <Flex>
                  <Text flex={3}>The number of purchases</Text>
                  <Text flex={1}>{summary.allPurchases}</Text>
                </Flex>
              </Box>
            </VStack>
            <VStack width="45%" p={4}>
              <Box w="100%" p={1} __css={rowStyles}>
                <Flex>
                  <Text flex={3}>
                    The number of Pro single module purchases
                  </Text>
                  <Text flex={1}>{summary.singleProPurchases}</Text>
                </Flex>
              </Box>
              <Box w="100%" p={1} __css={rowStyles}>
                <Flex>
                  <Text flex={3}>The number of Pro all module purchases</Text>
                  <Text flex={1}>{summary.allProPurchases}</Text>
                </Flex>
              </Box>
            </VStack>
          </Flex>
        </div>
        {filterData.length > 0 && (
          <div className="container-fluid bg-white rounded mt-2">
            <Table props={filterData} />
          </div>
        )}
      </div>
    </>
  );
};
